import React, { useMemo } from 'react'
import { staticImgs } from './constants'
import moment from 'moment'
import '../styles/web-content.scss'
import arrowLeft from 'assets/Images/arrow-left.png'
import arrowRight from 'assets/Images/arrow-right.png'
import { webContentStore } from 'state/setting/webContent'
import cardImage from 'assets/Images/ImageCard1.png'

const WebContent = () => {
  const {
    slides,
    headingBefore,
    headingColored,
    headingAfter,
    description,
    buttonText,
    buttonLink,
    gallery,
    type,
    videoLink,
    imageLink,
    commonEventId,
    currentSlide,
    setCurrentSlide,
  } = webContentStore()

  const effectiveSlides = useMemo(() => {
    if (Array.isArray(slides) && slides.length > 0) return slides
    // Fallback to a single slide using current editor state for preview when no slides loaded
    return [
      {
        id: 'preview-1',
        content: {
          headingBefore,
          headingColored,
          headingAfter,
          description,
          buttonText,
          buttonLink,
        },
        type: type,
        videoLink: videoLink,
        imageLink: imageLink,
        commonEventId: commonEventId,
        gallery: Array.from({ length: 9 }, () => ''),
      },
    ]
  }, [
    slides,
    headingBefore,
    headingColored,
    headingAfter,
    description,
    buttonText,
    buttonLink,
    type,
    videoLink,
    imageLink,
    commonEventId,
  ])
  return (
    <div className={`bg`}>
      <div className="relative">
        <div className={`hero_container`}>
          <div className={`carousel_main_container`}>
            {effectiveSlides.map((carouselItem, index) => {
              return (
                <div
                  className={`carousel_item ${index === 0 && 'active'}`}
                  style={{
                    transform: `${
                      index < currentSlide
                        ? 'translateX(-110%)'
                        : index > currentSlide
                        ? 'translateX(110%)'
                        : 'translateX(0)'
                    }`,
                  }}
                  key={carouselItem.id + '-' + currentSlide}
                >
                  <div className={`carousel_content`}>
                    <div className={`heading`}>
                      <h1 className={`heading1 main_heading`}>
                        {carouselItem.content.headingBefore}
                        {carouselItem.content.headingBefore.trim().length >
                          0 && <>&nbsp;</>}
                        <span className={`colored_text`}>
                          {carouselItem.content.headingColored}
                        </span>
                        {carouselItem.content.headingColored.trim().length >
                          0 && <>&nbsp;</>}
                        {carouselItem.content.headingAfter}
                      </h1>
                    </div>
                    <p className={`para hero_para`}>
                      {carouselItem.content.description}
                    </p>
                    {carouselItem.content.buttonText && (
                      <a href={carouselItem.content.buttonLink} target="_blank">
                        <button className={`button`}>
                          {carouselItem.content.buttonText}
                        </button>
                      </a>
                    )}
                  </div>

                  <div className={`carousel_gallery`}>
                    {staticImgs.map((staticImg, i) => {
                      return (
                        <div
                          className={`gallery_item ${[
                            `gallery_item_${i + 1}`,
                          ]}`}
                          key={i + '-' + currentSlide}
                        >
                          <div
                            className={`static_img ${[`static_img_${i + 1}`]}
                            }`}
                          >
                            <img
                              width={300}
                              height={300}
                              src={staticImg}
                              alt="img-content"
                              style={{ width: '100%', height: '100%' }}
                            />
                            {(() => {
                              const overlaySrc =
                                gallery?.[i]?.photo?.thumb ||
                                gallery?.[i]?.photo?.original ||
                                '' ||
                                carouselItem.gallery[i]
                              return overlaySrc &&
                                overlaySrc.trim().length > 0 ? (
                                <div className={`overlay_image`}>
                                  <img
                                    width={300}
                                    height={300}
                                    src={overlaySrc}
                                    alt="img-content"
                                    className={`${[`overlay_image_${i + 1}`]}`}
                                    style={{
                                      width: '100%',
                                      height: '100%',
                                      // objectFit: "cover",
                                      objectPosition: 'center',
                                    }}
                                  />
                                </div>
                              ) : null
                            })()}
                          </div>
                        </div>
                      )
                    })}

                    {carouselItem.type !== 'none' ? (
                      <div className={`gall_main`}>
                        {carouselItem.type === 'video' ? (
                          <div className={`video_container`}>
                            <iframe
                              src={carouselItem.videoLink}
                              className={`video`}
                              allow="autoplay; encrypted-media"
                            ></iframe>
                          </div>
                        ) : carouselItem.type === 'image' ? (
                          <div className="video_container">
                            <img
                              src={cardImage}
                              alt="card_image"
                              style={{
                                objectFit: 'cover',
                              }}
                            />
                          </div>
                        ) : (
                          <div className={`event_container`}>
                            <div className={`event_card`}>
                              <div className={`event_card_img`}>
                                <img
                                  src={cardImage}
                                  alt="img-content"
                                  width={500}
                                  height={500}
                                  style={{
                                    width: '100%',
                                    height: '100%',
                                    objectFit: 'cover',
                                  }}
                                />
                              </div>
                              <div className={`event_detail`}>
                                <h4 className="font12 b text-color-orange">
                                  Sep 11, 2025
                                </h4>
                                <h3 className="mt-5 font18 b">Name of event</h3>
                                <p className="mt-5 font14 b3">
                                  23232, Los Gatos, California, United States
                                </p>
                              </div>
                            </div>
                          </div>
                        )}
                      </div>
                    ) : null}
                  </div>
                </div>
              )
            })}
          </div>

          <div className={`func_btn_container`}>
            <button
              className={`arrow_button`}
              onClick={() => {
                const nextIndex =
                  currentSlide === 0
                    ? effectiveSlides.length - 1
                    : currentSlide - 1
                setCurrentSlide(nextIndex)
              }}
            >
              <img
                src={arrowLeft}
                width={50}
                height={50}
                alt="arrow-left"
                style={{ width: '100%', height: '100%', objectFit: 'cover' }}
              />
            </button>

            <div className={`dots_wrapper`}>
              {effectiveSlides.map((_, i) => {
                const active = i === currentSlide
                return (
                  <button
                    key={i}
                    onClick={() => setCurrentSlide(i)}
                    className={`custom-dot ${active ? 'active' : ''}`}
                    style={{
                      width: active ? '50px' : '6px',
                      height: '6px',
                      borderRadius: active ? '6px' : '50%',
                      margin: '0 5px',
                      backgroundColor: active ? '#262626' : '#26262633',
                      border: 'none',
                      cursor: 'pointer',
                    }}
                  />
                )
              })}
            </div>
            <button
              className={`arrow_button`}
              onClick={() => {
                const nextIndex =
                  currentSlide === effectiveSlides.length - 1
                    ? 0
                    : currentSlide + 1
                setCurrentSlide(nextIndex)
              }}
            >
              <img
                src={arrowRight}
                width={50}
                height={50}
                alt="arrow-right"
                style={{ width: '100%', height: '100%', objectFit: 'cover' }}
              />
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default WebContent
